export default __webpack_public_path__ + "static/media/blip-bored.63b5e0c4.svg";